import { signalStore, withState } from '@ngrx/signals';
import { initialEmployeeState } from './employee.state';
import { withEmployeeApiMethods } from './employee.methods.api';

export const EmployeeStore = signalStore(
  { providedIn: 'root' },
  withState(initialEmployeeState),
  withEmployeeApiMethods
);
